import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { AdOntology } from '../../../../main/types/adPartnerTypes';
import type { Action } from 'redux';

const GetAdOntology = new ReduxAsyncAction<'AD_PARTNER_GET_AD_ONTOLOGY', void, AdOntology[]>('AD_PARTNER_GET_AD_ONTOLOGY');

GetAdOntology.registerRequest(async () => {
  const { data } = await dash_api.get<AdOntology[]>(`/v1/ad-networks/ontology`);
  return data;
});

export const GET_AD_ONTOLOGY = GetAdOntology.actionNamespaceConstants;

export const getAdOntology = GetAdOntology.request;

export type GetAdOntologyResponseAction = Action<typeof GET_AD_ONTOLOGY.response> & { data: AdOntology[] };
